export const templates = {
  title: 'Szerződés sablonok',
  newTemplate: 'Új szerződés sablon',
  noTemplates: 'Nincs sablonok',
  placeholder: {
    search: 'Keresés...',
  },
  filter: {
    allTypes: 'Összes típus',
    contract: 'Szerződés',
    quotation: 'Árajánlat',
    warranty: 'Garancia',
    other: 'Egyéb',
  },
  fields: {
    name: 'Név',
    description: 'Leírás',
    type: 'Típus',
    createdAt: 'Létrehozás dátuma',
    usageCount: 'Használatok száma',
    actions: 'Műveletek',
    organization: 'Szervezet'
  },
  types: {
    contract: 'Szerződés',
    quotation: 'Árajánlat',
    warranty: 'Garancia',
    other: 'Egyéb',
  },
  actions: {
    download: 'Letöltés',
    preview: 'Előnézet',
    delete: 'Törlés',
    deleteSelected: 'Kijelöltek törlése'
  },
  deleteModal: {
    title: 'Szerződés sablon törlése',
    message: 'Biztosan törölni szeretné ezt a szerződés sablont?',
    warning: 'Ez a művelet nem visszavonható.',
    cancel: 'Mégse',
    delete: 'Törlés'
  },
  bulkDeleteModal: {
    title: 'Több szerződés sablon törlése',
    message: 'Biztosan törölni szeretné a kiválasztott {{count}} szerződés sablont?',
    warning: 'Ez a művelet nem visszavonható és érint minden kiválasztott sablont.'
  },
  createTemplateModal: {
    title: 'Új szerződés sablon létrehozása',
    description: "Új szerződés sablon létrehozása a név és leírás megadásával.",
    name: 'Szerződés sablon neve',
    namePlaceholder: 'Add meg a szerződés sablon nevét',
    descriptionPlaceholder: 'Add meg a szerződés sablon rövid leírását',
    documentType: 'Dokumentum típus',
    uploadTemplate: 'Szerződés sablon feltöltése',
    uploadTemplateDescription: 'Szerződés sablon feltöltése',
    cancel: 'Mégse',
    uploading: 'Feltöltés folyamatban...',
    uploadSuccess: 'Feltöltés sikeres',
    createTemplate: 'Szerződés sablon létrehozása',
    contract: 'Szerződés',
    quotation: 'Árajánlat',
    warranty: 'Garancia',
    supportedFormat: 'Támogatott formátum: .docx',
    availableFields: 'Elérhető mezők',
    organization: 'Szervezet',
    selectOrganization: 'Válassz szervezetet',
    fieldsDescription: 'A minta dokumentumban a felsorolt mezők automatikusan kitöltésre kerülnek a(z) {{type}} adatai alapján. További mezőket is hozzáadhatsz a dokumentumhoz a {{format}} formátumban, ezeket a generálás során manuálisan kell majd kitöltened.',
  },
  messages: {
    created: 'Szerződés sablon sikeresen létrehozva',
    error: 'Hiba történt a szerződés sablon létrehozása közben',
    deleted: 'Szerződés sablon sikeresen törölve',
    deleteError: 'Hiba történt a szerződés sablon törlése közben',
    bulkDeleted: '{{count}} sablon sikeresen törölve',
    bulkDeleteError: 'Hiba történt a sablonok tömeges törlése közben',
    noTemplatesSelected: 'Nincs kiválasztott sablon a törléshez'
  },
  selected: 'kiválasztva'
}
